import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "services/api.service";
import { Listing } from "types/listing";
import { useAlert } from "./useAlert";

export default function useListing() {
  const [listings, setListings] = useState<Listing[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [totalPages, setTotalPages] = useState<number>(0);
  const [count, setCount] = useState<number>(0);
  const { alertError, alertSuccess } = useAlert();

  const getListings = useCallback(async () => {
    setLoading(true);
    api
      .get(`/listings?${searchParams.toString()}`)
      .then(({ data }) => {
        setListings(data.listings);
        setCount(data.meta.count);
        setTotalPages(data.meta.totalPages);
      })
      .catch((error) => {
        alertError(`Failed to get Listings. ${error.message}`);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [alertError, searchParams]);

  useEffect(() => {
    getListings();
  }, [getListings]);

  const restartPricingBot = useCallback(async (listingId: number) => {
    api
      .put(`/listings/${listingId}/enable_automated_repricing`)
      .then((_data) => {
        alertSuccess("Pricing bot restarted");
      })
      .catch((error) => {
        alertError(`Failed to restart pricing bot. ${error.response.data.errors}`);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { listings, loading, getListings, count, totalPages, searchParams, setSearchParams, restartPricingBot };
}
